import { useQueryClient } from "@tanstack/react-query";

import activityKeys from "./query_keys";

export const useActivityInvalidate = () => {
  const cache = useQueryClient();
  return {
    invalidate: (activityIds?: number[]) => {
      if (!activityIds) {
        return cache.invalidateQueries(activityKeys.all());
      }
      return Promise.all(
        activityIds.map((activityId) => {
          cache.invalidateQueries({
            queryKey: activityKeys.activity(activityId)
          });
          cache.invalidateQueries({
            queryKey: activityKeys.bookingActivity(activityId)
          });
        })
      );
    },
    removeCache: (activityIds?: number[]) => {
      if (!activityIds) {
        cache.removeQueries(activityKeys.all());
        return;
      }
      activityIds.forEach((activityId) => {
        cache.removeQueries({
          queryKey: activityKeys.activity(activityId)
        });
        cache.removeQueries({
          queryKey: activityKeys.bookingActivity(activityId)
        });
      });
    },
    invalidateWatchers: (activityId) => cache.invalidateQueries(activityKeys.watchers(activityId)),
    invalidateFeedbacks: () => cache.invalidateQueries(activityKeys.feedback()),
    invalidateFeedbackParticipants: (activityId) =>
      cache.invalidateQueries(activityKeys.feedbackParticipants(activityId)),
    invalidateVacancies: (activityId) => cache.invalidateQueries(activityKeys.vacancies(activityId)),
    invalidateActivityWarnings: (activityId) => cache.invalidateQueries(activityKeys.warnings(activityId))
  };
};
